import { render, staticRenderFns } from "./ResourceCategorySelector.vue?vue&type=template&id=c9627bb2&scoped=true"
import script from "./ResourceCategorySelector.vue?vue&type=script&lang=js"
export * from "./ResourceCategorySelector.vue?vue&type=script&lang=js"
import style0 from "./ResourceCategorySelector.vue?vue&type=style&index=0&id=c9627bb2&prod&scoped=true&lang=css"
import style1 from "./ResourceCategorySelector.vue?vue&type=style&index=1&id=c9627bb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9627bb2",
  null
  
)

export default component.exports